import funciones from "./funcion/funcion";
import sistema from "./sistema/forseti";
import catalogos from "./catalogos/forseti";

const Forseti = {
  sistema: sistema,
  catalogos: catalogos,
  funciones: funciones
}

export default Forseti



//////////////////
// WEBPACK FOOTER
// ./static/js/api/forseti/forsetiapi.js
// module id = null
// module chunks = 